import React from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'utils/modifiedTranslation';
import { SIDEBAR_POSITIONS } from 'components/Sidebar/sidebarSettings';
import leftArrow from '../icons/left-arrow.svg';
import rightArrow from '../icons/right-arrow.svg';

const useStyles = makeStyles(() => ({
  direction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '.rtl &': {
      justifyContent: 'center',
    },
  },
  leftArrow: {
    marginRight: 4,
    '.rtl &': {
      transform: 'rotate(180deg)',
    },
  },
  rightArrow: {
    marginLeft: 4,
    '.rtl &': {
      transform: 'rotate(180deg)',
    },
  },
  content: {
    fontWeight: 400,
    fontSize: 14,
    color: '#FF8C69',
  },
}));

export const NavButton = ({
  to, content, onClick,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Button className={classes.direction} onClick={onClick}>
      {to === SIDEBAR_POSITIONS.LEFT && <img src={leftArrow} alt="left-arrow" className={classes.leftArrow} />}
      <Typography variant="body1" className={classes.content}>
        {t(content)}
      </Typography>
      {to === SIDEBAR_POSITIONS.RIGHT && <img src={rightArrow} alt="right-arrow" className={classes.rightArrow} />}
    </Button>
  );
};

NavButton.propTypes = {
  to: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
